/* Flechas de las reseñas W&M en ORDENADOR (27-oct, Igor). Solo ficha; en móvil se ocultan por CSS y se sigue con el dedo. */
(function () {
  function init() {
    if (!document.querySelector('.mf-product-section')) return;
    document.querySelectorAll('.seccion-resenas-wm .rwm__track').forEach(function (track) {
      if (track.parentElement.classList.contains('rwm__wrap')) return;
      var wrap = document.createElement('div');
      wrap.className = 'rwm__wrap';
      track.parentNode.insertBefore(wrap, track);
      wrap.appendChild(track);
      function mk(dir) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'rwm__arr rwm__arr--' + dir;
        b.setAttribute('aria-label', dir === 'next' ? 'Recensioni successive' : 'Recensioni precedenti');
        b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + (dir === 'next' ? 'M9 5l7 7-7 7' : 'M15 5l-7 7 7 7') + '"/></svg>';
        wrap.appendChild(b);
        return b;
      }
      var prev = mk('prev'), next = mk('next');
      function step() {
        var c = track.querySelector('.rwm__card');
        return c ? c.offsetWidth + 18 : 400;
      }
      function upd() {
        var max = track.scrollWidth - track.clientWidth;
        prev.hidden = track.scrollLeft < 8;
        next.hidden = track.scrollLeft > max - 8;
      }
      function go(d) {
        var from = track.scrollLeft;
        track.scrollBy({ left: d, behavior: 'smooth' });
        setTimeout(function () { if (Math.abs(track.scrollLeft - from) < 2) track.scrollBy({ left: d, behavior: 'instant' }); }, 700);
      }
      prev.addEventListener('click', function () { go(-step()); });
      next.addEventListener('click', function () { go(step()); });
      track.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
      setTimeout(upd, 400);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
